"use strict";

window.addEventListener('DOMContentLoaded', function (event) {
  var awardsCarousel = document.querySelectorAll('.awards-carousel');
  if (awardsCarousel.length > 0) {
    var glideArrows = document.querySelectorAll('.glide__arrows');
    var mediaQueryAbove = window.matchMedia('(min-width: 1200px)');
    var awardSliders = document.querySelectorAll('.awards-carousel__container');
    var sliderCount = document.querySelectorAll('.awards-carousel .glide__slide:not(.awards-carousel .glide__slide--clone)');
    awardsCarousel.forEach(function (item) {
      item.classList.remove('awards-carousel--small');
    });
    var _loop = function _loop() {
      var awardItems = awardsCarousel[i].querySelectorAll('.glide__slide');
      if (awardItems.length <= 4) {
        awardsCarousel[i].classList.add('awards-carousel--small');
        var glide = new Glide(awardSliders[i], {
          type: 'slider',
          animationTimingFunc: 'ease-in-out',
          swipeThreshold: false,
          dragThreshold: false,
          breakpoints: {
            1200: {
              type: 'carousel',
              focusAt: 'center',
              swipeThreshold: true,
              dragThreshold: true,
              perView: 1
            }
          }
        });
        glide.on('mount.after', function () {
          awardItems.forEach(function (item) {
            item.addEventListener("mouseenter", function (e) {
              awardItems.forEach(function (item) {
                item.classList.remove("glide__slide--active");
              });
            });
            item.addEventListener("mouseleave", function (e) {
              this.classList.remove("glide__slide--active");
            });
          });
          if (mediaQueryAbove.matches) {
            for (var i = 0; i < sliderCount.length; i++) {
              if (sliderCount.length <= 5) {
                glideArrows.forEach(function (nav) {
                  nav.style.display = "none";
                });
                awardItems.forEach(function (item) {
                  if (item.classList.contains("glide__slide--active")) {
                    item.classList.add("glide-center");
                  }
                });
              }
            }
          }
          for (var i = 0; i < sliderCount.length; i++) {
            if (sliderCount.length <= 1) {
              glideArrows.forEach(function (nav) {
                nav.style.display = "none";
              });
            }
          }
        });
        if (mediaQueryAbove.matches) {
          glide.disable();
        } else {
          glide.mount();
        }
      } else {
        var _glide = new Glide(awardSliders[i], {
          type: 'carousel',
          focusAt: 'center',
          animationTimingFunc: 'ease-in-out',
          perView: 5,
          swipeThreshold: false,
          dragThreshold: false,
          breakpoints: {
            1200: {
              type: 'carousel',
              swipeThreshold: true,
              dragThreshold: true,
              perView: 3
            },
            767: {
              type: 'carousel',
              swipeThreshold: true,
              dragThreshold: true,
              perView: 1
            }
          }
        });
        _glide.on('mount.after', function () {
          awardItems.forEach(function (item) {
            item.addEventListener("mouseenter", function (e) {
              awardItems.forEach(function (item) {
                item.classList.remove("glide__slide--active");
              });
            });
            item.addEventListener("mouseleave", function (e) {
              this.classList.remove("glide__slide--active");
            });
          });
          if (mediaQueryAbove.matches) {
            for (var i = 0; i < sliderCount.length; i++) {
              if (awardItems.length <= 5) {
                glideArrows.forEach(function (nav) {
                  nav.style.display = "none";
                });
                awardItems.forEach(function (item) {
                  if (item.classList.contains("glide__slide--active")) {
                    item.classList.add("glide-center");
                  }
                });
              }
            }
          }
        });
        _glide.mount();
      }
    };
    for (var i = 0; i < awardsCarousel.length; i++) {
      _loop();
    }
  }
});